// constants
import { supportedPlanningEntityTypes } from '../../EntitySearch.consts';

// styles
import {
  EntitySearchFilterContainer,
  FilterChip
} from './EntitySearchFilter.styles';

// types
import { PlanningEntityType } from 'generated/index';
import { EntitySearchFilterProps } from './EntitySearchFilter.types';
import { useTranslation } from 'react-i18next';
import { MouseEvent } from 'react';

export const EntitySearchFilter = ({
  activeFilter,
  entityTypeFilters,
  onSelectEntityType
}: EntitySearchFilterProps) => {
  const { t } = useTranslation('common', { keyPrefix: 'mrp' });

  const handleSelectEntity = (
    event: MouseEvent<HTMLElement>,
    entityType: PlanningEntityType | null
  ) => {
    event.preventDefault();
    event.stopPropagation();
    onSelectEntityType?.(entityType);
  };

  return (
    <EntitySearchFilterContainer>
      <FilterChip
        label={t('all')}
        onClick={(event) => handleSelectEntity(event, null)}
        variant={activeFilter.length === 0 ? 'filled' : 'outlined'}
      />

      {supportedPlanningEntityTypes
        .filter(
          (entityType) =>
            entityTypeFilters.length === 0 ||
            entityTypeFilters.includes(entityType)
        )
        .map((entityType) => (
          <FilterChip
            key={entityType}
            label={t(`entityTypeMap.${entityType}.plural`)}
            onClick={(event) => handleSelectEntity(event, entityType)}
            variant={activeFilter.includes(entityType) ? 'filled' : 'outlined'}
          />
        ))}
    </EntitySearchFilterContainer>
  );
};

export default EntitySearchFilter;
